export const REFRESH_INTERVAL = 800; // millisecond
export const HOURS_CONVERSION = 60 * 60 * 1000;
export const MINUTES_CONVERSION = 60 * 1000;
export const SECONDS_CONVERSION = 1000;
export const MILLISECONDS_CONVERSION = 1;